import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { emptyECMR, saveECMRWithSync } from '../services/eCMRService';
import { ECMR } from '../types/eCMR';
import ECMRForm from './ECMRForm';
import { safeConsoleError } from '../utils/safeConsole';
import { validateCmrDocument } from '../compliance/validateCmrDocument';

const CreateECMR: React.FC = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState<boolean>(false);
  
  const handleSubmit = async (data: ECMR) => {
    setSaving(true);
    try {
      // Asignar fecha actual si no existe
      if (!data.ExchangedDocument?.IssueDateTime?.DateTimeString) {
        const now = new Date();
        const formattedDateTime = now.toISOString().replace(/\D/g, '').substring(0, 14);
        
        data.ExchangedDocument = {
          ...data.ExchangedDocument,
          IssueDateTime: {
            DateTimeString: formattedDateTime
          }
        };
      }
      
      // Crear ID automático si no existe
      if (!data.ExchangedDocument?.ID) {
        data.ExchangedDocument = {
          ...data.ExchangedDocument,
          ID: `CMR-${Math.floor(Math.random() * 1000000).toString().padStart(6, '0')}`
        };
      }

      const cmrValidation = validateCmrDocument(data);
      const blockingErrorCount = cmrValidation.errors.filter((validationError) => validationError.severity === 'error').length;
      if (!cmrValidation.valid || blockingErrorCount > 0) {
        alert(`No se pudo guardar el e-CMR: faltan ${blockingErrorCount} requisitos CMR/eCMR obligatorios. Revise los campos obligatorios antes de guardar.`);
        return;
      }
      
      // Save with sync (creates new document)
      const result = await saveECMRWithSync(data, data.ExchangedDocument?.ID);
      
      if (result.success && result.apiDocument) {
        navigate(`/view/${result.apiDocument.document_id}?source=api`);
      } else {
        alert('No se pudo guardar el e-CMR en la nube. Inicia sesión y vuelve a intentarlo.');
      }
    } catch (error) {
      safeConsoleError('Error al guardar el e-CMR', 'document.create.save');
      alert('Error al guardar el e-CMR');
    } finally {
      setSaving(false);
    }
  };
  
  const handleCancel = () => {
    navigate('/');
  };
  
  return (
    <div className="container mx-auto p-4">
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-2">Crear Nuevo e-CMR</h1>
        {saving && (
          <div className="text-blue-600">
            <i className="fas fa-spinner fa-spin mr-2"></i>
            Guardando documento...
          </div>
        )}
      </div>
      
      <ECMRForm
        initialData={emptyECMR}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        disabled={saving}
      />
    </div>
  );
};

export default CreateECMR;
